import React from 'react';
import { connect } from 'react-redux';
import { number, object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import CheckoutFormHOC from '../shared/CheckoutFormHOC';
import PackageContent from '../shared/PackageContent';
import SafePureComponent from '../shared/SafePureComponent';
import { getPackageById, getSingleCalculator } from '../../reducers/packages';
import { shouldShowSelectPackage } from '../../utils/shouldShowSelectPackage';
import { BASIC_PACKAGE_ID } from '../../utils/packagesUtils/constants';
import { shouldDisplayFinalPriceUpfront } from '../../utils/experiments/finalPriceUpfront';
import PackageExtras from './PackageExtras';
import GigQuantity from './GigQuantity';
import TotalPrice from './TotalPrice';

import './style.scss';

const OrderDetails = ({
    currentPrice,
    calculator
},
{
    general,
    currencyConverter
}) => {
    const formattedPrice = currencyConverter.convertWithFee(currentPrice);
    const showSelectPackage = shouldShowSelectPackage(general);
    const showTotalPrice = shouldDisplayFinalPriceUpfront();

    return (
        <div className="order-details">
            <h2 className="section-title"><I18n k={'gig_page_perseus.packages.order_details'}/></h2>
            <div className="content">
                <PackageContent id={BASIC_PACKAGE_ID} showPrice={false} forceNonCollapsable={true}/>
                {!calculator &&
                <GigQuantity/>
                }
                <PackageExtras/>
                { showTotalPrice && <TotalPrice/> }
                {showSelectPackage &&
                <div className="button-wrapper">
                    <Button className="submit-button" type="submit">
                        <I18n k={'gig_page_perseus.packages.continue'}/>
                        <span> ({formattedPrice})</span>
                    </Button>
                </div>
                }
            </div>
        </div>
    );
};

OrderDetails.propTypes = {
    currentPrice: number,
    calculator: object
};

OrderDetails.contextTypes = {
    general: object,
    currencyConverter: object
};

const mapStateToProps = ({ packages }) => {
    const { currentPrice } = getPackageById(packages, BASIC_PACKAGE_ID);
    const calculator = getSingleCalculator(packages, BASIC_PACKAGE_ID);

    return {
        currentPrice,
        calculator
    };
};

const OrderDetailsConnect = connect(mapStateToProps)(OrderDetails);

const OrderDetailsWrapper = () => (
    <CheckoutFormHOC selectedPackageId={BASIC_PACKAGE_ID}
        source="Bottom Main">
        <OrderDetailsConnect/>
    </CheckoutFormHOC>
);

export { OrderDetailsWrapper, OrderDetails };
export default SafePureComponent(OrderDetailsWrapper);
